<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body class="form-card">
          <!-- Title -->
          <div class="mt-1 px-2">
            <div class="d-flex justify-content-between align-items-center">
              <p class="mb-0 fs-18 title text-muted text-uppercase" style="font-weight: 400; letter-spacing: .05rem;">
                filtros
              </p>
              <b-button variant="outline-dark" @click="resetForm">
                <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                Limpiar Filtros
              </b-button>
            </div>
          </div>
          <!-- modules -->
          <div class="mt-2">
            <div class="title-container">
              <div class="d-flex align-items-end">
                <div id="module-number" :class="[form.selectedModuleId ? 'completed' : '']">
                  <span>1</span>
                </div>
                <p class="mb-0 fs-18 title">Módulo de la aplicación <span class="text-danger">*</span></p>
              </div>
            </div>
            <b-form-select
              v-model="form.selectedModuleId"
              :options="appModules"
              class="mb-2 mb-sm-0 mr-2 mr-sm-0 fs-18"
              style="width: 100%"
              @change="selectModule"
            >
              <template #first>
                <b-form-select-option :value="null">-- Seleccione un módulo --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
          <!-- permissions -->
          <div class="mt-3">
            <div class="title-container">
              <div class="d-flex align-items-end">
                <div id="module-number" :class="[form.selectedActionId ? 'completed' : '']">
                  <span>2</span>
                </div>
                <p class="mb-0 fs-18 title">Permiso del módulo <span class="text-danger">*</span></p>
              </div>
            </div>
            <div class="d-flex align-items-center gap-2 w-100">
              <b-form-select
                v-model="form.selectedActionId"
                :options="approvalActions"
                class="fs-18 flex-grow-1"
                :disabled="!form.selectedModuleId"
                @change="selectAction"
              >
                <template #first>
                  <b-form-select-option :value="null">-- Seleccione un permiso --</b-form-select-option>
                </template>
              </b-form-select>
              <div class="flex-shrink-0">
                <b-button
                  variant="light"
                  class="ml-2 mr-1"
                  :disabled="!form.selectedModuleId || !form.selectedActionId"
                  v-b-tooltip.hover.v-dark.topleft='form.selectedActionId ? selectedAction.description || "" : "Seleccione un permiso para ver su descripción"'
                >
                  <font-awesome-icon
                    :icon="['far', 'info-circle']"
                    fixed-width
                    size="lg"
                  />
                </b-button>
                <b-button
                  variant="outline-success"
                  :disabled="!form.selectedModuleId || !form.selectedActionId"
                  v-b-tooltip.hover.v-dark.topleft="'Descargar reporte por permiso de módulo'"
                  @click="downloadReport"
                >
                  <font-awesome-icon :icon="['far', 'download']" fixed-width />
                  <span>Reporte CSV</span>
                </b-button>
              </div>
            </div>
          </div>
          <!-- groups -->
          <div class="mt-3 mb-1">
            <div class="title-container mt-1">
              <div class="d-flex align-items-center">
                <div id="module-number" :class="[form.selectedGroupId ? 'completed' : '']">
                  <span>3</span>
                </div>
                <p class="mb-0 fs-18 title">Grupo de autorización <span class="text-danger">*</span></p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <b-form-select
                v-model="form.selectedGroupId"
                :options="actionGroups"
                class="fs-18"
                style="width: 100%"
                :disabled="!form.selectedModuleId || !form.selectedActionId"
              >
                <template #first>
                  <b-form-select-option :value="null">-- Seleccione un grupo --</b-form-select-option>
                </template>
              </b-form-select>
              <b-button
                variant="outline-primary"
                :disabled="!form.selectedModuleId || !form.selectedActionId"
                class="flex-shrink-0 ml-2"
                @click="openNewGroupModal"
              >
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
                Grupo
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- new group modal -->
    <Modal
      v-if="newGroupModalShow"
      contentWidth="800px"
      :required=true
      @close="closeNewGroupModal"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          Nuevo grupo para <b>{{ selectedAction.text }}</b>
        </p>
      </template>
      <template #body>
        <b-row>
          <b-col>
            <!-- name -->
            <div class="mb-2">
              <p class="mb-0 fs-18 mb-1">Nombre del grupo <span class="text-danger">*</span></p>
              <b-input
                v-model="newGroupForm.name"
                type="text"
                trim
                class="fs-18"
                style="width: 100%;"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              variant="outline-success"
              class="float-right ml-3"
              :disabled="!newGroupForm.name"
              @click="createNewGroup"
            >
              <span>Crear</span>
            </b-button>
            <b-button variant="outline-danger" class="float-right" @click="closeNewGroupModal">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapGetters} from 'vuex'
import { format } from 'date-fns'

import UserSearchInput from '../../../components/shared/UserSearchInput'
import Modal from '../../../components/shared/Modal'

export default {
  name: 'FiltersCard',
  components: { UserSearchInput, Modal },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      newGroupModalShow: false,
      newGroupForm: {
        name: ''
      },
      selectedAction: {},
      appModules: [],
      actionGroups: [],
      approvalActions: [],
      modulesPermissionsMap: {
        'tarjetas': 'Reglas de Aprobación - Tarjetas',
      }
    }
  },
  mounted () {
    this.fetchAppModules()
  },
  computed: {
    ...mapGetters({
      isDev: 'isDev',
      permissions: 'approvalRulesPermissions'
    })
  },
  methods: {
    fetchAppModules () {
      this.$http.get('/api/approval_modules')
        .then(response => {
          // console.log(response.data)
          this.formatAppModules(response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    formatAppModules (modules) {
      const appModules = modules.map(m => {
        const baseModule = { text: m.name, value: m.id, disabled: false, code: m.code }

        if (!this.isDev) {
          const UserHasPermission = this.permissions.includes(this.modulesPermissionsMap[m.code])
          return {
            ...baseModule,
            text: UserHasPermission ? m.name : `${m.name} (No tiene permiso)`,
            disabled: !UserHasPermission,
          }
        }

        return baseModule
      })

      this.appModules = this.sortOptions(appModules)
    },
    selectModule (selectedModuleId) {
      const moduleApp = this.appModules.find(m => m.value === selectedModuleId) || {}
      this.$emit('select-module', moduleApp)

      this.resetActionsState()
      this.resetActionGroupsState()

      if (!this.form.selectedModuleId) return

      this.fetchApprovalActions()
    },
    selectAction (selectedActionId) {
      this.selectedAction = this.approvalActions.find(a => a.value === selectedActionId) || {}
      this.$emit('select-action', this.selectedAction)

      this.resetActionGroupsState()

      if (!this.form.selectedActionId) return

      this.fetchActionGroups()
    },
    resetActionsState () {
      this.approvalActions = []
      this.form.selectedActionId = null
      this.selectedAction = {}
    },
    resetActionGroupsState () {
      this.actionGroups = []
      this.form.selectedGroupId = null
    },
    fetchApprovalActions () {
      this.$http.get(`/api/approval_modules/${this.form.selectedModuleId}/approval_actions`)
        .then(response => {
          // console.log(response.data)
          this.approvalActions = this.sortOptions(response.data.map(action => (
            { text: action.name, value: action.id, description: action.description }
          )))
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchActionGroups () {
      this.$http.get(`/api/approval_modules/${this.form.selectedModuleId}/approval_actions/${this.form.selectedActionId}/approval_groups`, {
        params: {
          active_groups: true
        }
      })
        .then(response => {
          // console.log(response.data)
          this.actionGroups = this.sortOptions(response.data.map(group => (
            { text: group.name, value: group.id }
          )))
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetForm () {
      this.form.selectedModuleId = null
      this.form.selectedActionId = null
      this.form.selectedGroupId = null
      this.selectedAction = {}
      this.$emit('reset-filters')
    },
    openNewGroupModal () {
      this.newGroupModalShow = true
      this.newGroupForm.name = ''
    },
    closeNewGroupModal () {
      this.newGroupForm.name = ''
      this.newGroupModalShow = false
    },
    createNewGroup () {
      this.$http.post(`/api/approval_modules/${this.form.selectedModuleId}/approval_actions/${this.form.selectedActionId}/approval_groups`, {
          approval_group: {
            name: this.newGroupForm.name
          }
        })
        .then(response => {
          // console.log(response)
          const { id, name } = response.data
          this.actionGroups.unshift(
            { text: name, value: id }
          )
          this.form.selectedGroupId = id

          this.closeNewGroupModal()
          this.$emit('display-alert', {
            variant: 'success',
            message: 'Grupo creado correctamente'
          })
        })
        .catch(error => {
          // console.log(error)
          let message = error.response?.data?.error || ''
          if (message.includes('Code ya está en uso')) {
            message = 'El nombre del grupo ya está en uso, intente con uno diferente'
          }
          this.$emit('display-alert', {
            variant: 'danger',
            message
          })
        })
    },
    downloadReport () {
      this.$http.get(`/api/approval_modules/${this.form.selectedModuleId}/approval_actions/${this.form.selectedActionId}/download_report`)
        .then(res => {
          // console.log(res)
          const blob = new Blob([res.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `Reporte_${format(new Date, 'd-M-yyyy')}.csv`
          link.click()
        })
        .catch(error => {
          // console.log(error)
          this.$emit('display-alert', {
            variant: 'danger',
            message: 'Hubo un error al descargar el reporte, intente nuevamente'
          })
        })
    },
    normalizeString (str) {
      return str?.toString()
                  .toLowerCase()
                  .trim()
                  .replace(/\s+/g, " ") // replace multiple spaces with one
                  .replace(/[áÁ]/g, 'a')
                  .replace(/[éÉ]/g, 'e')
                  .replace(/[íÍ]/g, 'i')
                  .replace(/[óÓ]/g, 'o')
                  .replace(/[úÚ]/g, 'u')
    },
    sortOptions (options) {
      return options.sort((a, b) => a.text.localeCompare(b.text, 'es'))
    }
  }
}
</script>


<style scoped>
  #module-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: #1b1a1a;
    border: #1b1a1a solid 1px;
    border-radius: 50%;
    margin-right: 6px;
  }
  #module-number.completed {
    color: #fff;
    border: #1C7BFF solid 1px;
    background-color: #1C7BFF;
  }
  .form-card {
    border-radius: 8px;
    padding: 10px 15px;
    border: 2px solid #e2e8f0;
    min-height: 100px;
  }
  .title-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: .25rem;
  }
  .title {
    line-height: 19px;
  }
  @media (max-width: 991.98px) {
    .title-container button {
      font-size: 12px;
    }
    .title {
      font-size: 1.0625rem;
    }
  }
</style>
